import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Status } from '../../../helpers/enum';
import { LocalCampaignOrderDataStatisticsModel, RenaultLocalCampaignOrderListDTO } from '../../../models/renault-local-campaign-order-dto';
import { LocalCampaignOrderService } from '../../../services/local-campaign-order.service';
import { LocalCampaignHtmlModalComponent } from '../local-campaign-html-modal/local-campaign-html-modal.component';
import { LocalCampaignMedia } from '../../../helpers/enum';
import { Helpers } from '../../../helpers/helpers';
import { Router } from '@angular/router';
import { LocalCampaignTelemarketingOrderDataStatisticsModel } from '../../../models/renault-local-campaign-telemarketing-order-dto';
import { LocalCampaignTelemarketingOrderService } from '../../../services/local-campaign-telemarketing-order.service';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { LocalCampaignTelemarketingOrderDataService } from 'src/app/services/local-campaign-telemarketing-order-data.service';
import { UserService } from 'src/app/services/user.service';
import { RenaultUserDTO } from 'src/app/models/renault-user-dto';
import * as moment from 'moment';
import { DeclinedReasonComponent } from '../declined-reason-modal/declined-reason-modal.component';

@Component({
  selector: 'local-campaign-order-list-card',
  templateUrl: './local-campaign-order-list-card.component.html',
  styleUrls: ['./local-campaign-order-list-card.component.scss']
})
export class LocalCampaignOrderListCardComponent implements OnInit {

  @Input() model: RenaultLocalCampaignOrderListDTO;
  @Output("refreshList") refreshList: EventEmitter<any> = new EventEmitter();
  modelStatistics: LocalCampaignOrderDataStatisticsModel;
  modelStatisticsTmk: LocalCampaignTelemarketingOrderDataStatisticsModel;
  enviados: number = 0;
  error: number = 0;
  reactividad: number = 0;
  LocalCampaignMedia = LocalCampaignMedia;
  status: string = "";
  modalCampaignDistributors = [];
  user: RenaultUserDTO;
  loaded = false;
  actualDate = new Date(moment(new Date()).format("YYYY-MM-DDTHH:mm:ss"));
  desiredDate;
  crmOnlyCalls = false;

  constructor(private service: LocalCampaignOrderService,
    private tmkService: LocalCampaignTelemarketingOrderService,
    private tmkDataService: LocalCampaignTelemarketingOrderDataService,
    private router: Router,
    private modalService: NgbModal,
    private userService: UserService,
    private toastr: ToastrService,
    private helper: Helpers) { }

  ngOnInit(): void {

    this.desiredDate = new Date(moment(this.model.DesiredDate).format("YYYY-MM-DDTHH:mm:ss"));

    this.getUserInfo();
    if (this.model.IdCampaignMedia == LocalCampaignMedia.Email || this.model.IdCampaignMedia == LocalCampaignMedia.Sms) {
      this.service.getLocalCampaignOrderStatistics(this.model.IdOrderInt).subscribe(resp => {
        this.modelStatistics = resp;
        this.loaded = true;
        this.enviados = this.modelStatistics.Status.find(x => x.IdStatus == Status.Enviado)?.Contador ?? 0;
        this.error = this.modelStatistics.Status.find(x => x.IdStatus == Status.Error)?.Contador ?? 0;
        if (this.modelStatistics.Abiertos > 0) {
          this.reactividad = this.modelStatistics.ClicksTotales * 100 / this.modelStatistics.Abiertos;
        }
        this.checkStatus();
      });
    } else if (this.model.IdCampaignMedia == LocalCampaignMedia.Telemarketing) {
      this.tmkService.getLocalCampaignTelemarketingOrderStatistics(this.model.IdOrderInt).subscribe(resp => {
        this.modelStatisticsTmk = resp;
        this.checkStatus();
      });
    }
  }

  getUserInfo() {
    this.userService.getUserData().subscribe(res => {
      if(res == null) return;
      this.user = res;
      if (res.RolesListString.some(x => x == "RedCallcenter") && !res.RolesListString.some(x => x == "ResponsablePv" || x == "RedRespMktg" || x == "RedJefeTaller")) this.crmOnlyCalls = true;
    });
  }

  ngAfterViewChecked(): void {
    this.helper.enableBsTooltips();
  }

  checkStatus() {
    if (this.model.IdStatus != 3 && this.model.IdStatus != 6 && this.model.IdStatus != 11 && this.model.IdStatus != 8 && this.model.IdStatus != 19 && this.model.IdStatus != 20 && this.model.IdStatus != 21 && this.enviados == 0) {
      this.status = "SIN CONTACTOS";
      this.model.Status = "SIN CONTACTOS";

    }
    else {
      this.status = this.model.Status;
    }

    if (this.model.IdStatus == 3 && this.model.HasOrderValidation) {
      this.status += ' DE APROBACIÓN'
    }
  }

  showCampaignHtml() {
    const modalRef = this.modalService.open(LocalCampaignHtmlModalComponent, { centered: true, size: 'lg' });
    modalRef.componentInstance.idOrder = this.model.IdOrder;
  }

  showCampaignDistributors(content, campaignDistributors) {
    const modalRef = this.modalService.open(content, { centered: true, modalDialogClass: 'modal-distributor-list' });
    this.modalCampaignDistributors = campaignDistributors;
  }

  goToDetail(campaignMedia) {
    var media = '';
    switch (campaignMedia) {
      case LocalCampaignMedia.Email:
        media = 'email';
        break;
      case LocalCampaignMedia.Sms:
        media = 'sms';
        break;
      default:
        break;
    }
    this.router.navigate(['/campaigns/local-campaign/' + media + '/statistics/' + this.model.IdOrder]);
  }

  continueCampaign() {
    this.router.navigate(['/campaigns/local-campaign/request/' + this.model.IdOrder]);
  }

  deleteCampaign() {
    Swal.fire({
      title: '¿Quieres eliminar esta campaña?',
      text: "La campaña se eliminará del listado",
      icon: 'warning',
      buttonsStyling: false,
      customClass: {
        cancelButton: 'btn btn-primary me-2',
        confirmButton: 'btn btn-outline-secondary'
      },
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonText: '<i class="fa fa-trash-o" aria-hidden="true"></i> Eliminar',
      cancelButtonText: '<i class="fa fa-times" aria-hidden="true"></i> Cancelar',
      cancelButtonColor: '#d33',
      reverseButtons: true,
      focusCancel: true
    }).then((result) => {
      if (result.value) {
        this.service.changeStatus(this.model.IdOrder, Status.Baja).subscribe(() => {
          this.toastr.success("La campaña se ha eliminado correctamente");
          this.refreshList.emit();
        }, (err) => {
          Swal.fire({
            icon: 'error',
            title: 'Error al eliminar el elemento',
            text: 'Ocurrió un error',
            buttonsStyling: false,
            customClass: {
              confirmButton: 'btn btn-outline-secondary'
            },
            confirmButtonText: 'Cerrar'
          });
        });
      }
    })
  }

  updateOrderDataStatus() {

    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Espere por favor...'
    });
    Swal.showLoading();

    this.tmkDataService.UpdateTelemarketingOrderDataStatus(this.model.IdOrder).subscribe(res => {
      Swal.close();
      this.router.navigate(['/campaigns/local-campaign/telemarketing/call-management/' + this.model.IdOrder]);

    }, (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Error al recuperar los datos',
        text: 'Ocurrió un error',
            buttonsStyling: false,
            customClass: {
              confirmButton: 'btn btn-outline-secondary'
            },
            confirmButtonText: 'Cerrar'
          });
    });
  }

  getDeclinedReason(idOrder) {

    const modalRef = this.modalService.open(DeclinedReasonComponent, { centered: true, size: 'md' });

    modalRef.componentInstance.idOrder = idOrder;

  }

}
